const config = {
  baseUrl: process.env.VUE_APP_ROOT_API as string,
  googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY as string,
}

export default config
